export default __webpack_public_path__ + "static/media/AboutMarina.0c0987da.jpg";